import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Paper, Typography, Box, Grid, Autocomplete, InputLabel, MenuItem, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import Select from "react-select";
import Swal from "sweetalert2";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import generateAdmissionForm from "./generateAdmissionForm";
import { useForm, Controller } from "react-hook-form";
import api from "../../api";
import { Cropper, RectangleStencil } from "react-advanced-cropper";
import "react-advanced-cropper/dist/style.css";
import { useParams } from "react-router-dom";
import Modal from "react-modal";
Modal.setAppElement("#root");

const AddStudent = () => {

  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const { control, formState: { errors } } = useForm();
  const [usedRolls, setUsedRolls] = useState([]);

  const [student, setStudent] = useState({
    name: "",
    dob: "",
    aadhaar_no: "",
    blood_group: "",
    gender: "",
    category: "",
    fatherName: "",
    f_aadhaar_no: "",
    motherName: "",
    m_aadhaar_no: "",
    mobile: "",
    email: "",
    state: "",
    district: "",
    block: "",
    locality: "",
    village: "",
    post_office: "",
    police_station: "",
    pincode: "",
    classes: "",
    sections: "",
    stream: "",
    roll_no: "",
    bpl_no: "",
    admission_fees: "",
    banks: "",
    account_no: "",
    ifsc_code: "",
    file: "",
    transportLocations: "",
    academic_year_id: "",
    fees: []


  });

  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [banks, setBanks] = useState([]);
  // Image crop states
  const [image, setImage] = useState(null);
  const [cropper, setCropper] = useState(null);
  const [croppedImg, setCroppedImg] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [oldImagePath, setOldImagePath] = useState("");

  // class & sec
  const [classes, setClass] = useState([]);
  const [sections, setSections] = useState([]);
  const [stream, setStream] = useState([]);
  const [fees, setFees] = useState([]);
  const [transportLocations, setTransportLocations] = useState([]);
  const [defaultCheckedFees, setDefaultCheckedFees] = useState([]);
  const schoolId = localStorage.getItem("school_id");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editStudentId, setEditStudentId] = useState(null);

  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      setEditStudentId(atob(id));
      fetchStudentForEdit(atob(id)); // 🔥 next step
    }
  }, [id]);

  useEffect(() => {
    fetchSessions();   // 🔥 always
  }, []);



  const fetchStudentForEdit = async (studentId) => {
    try {
      // API expects base64 id
      const encodedId = btoa(String(studentId));

      const res = await api.get(`/view-student-details/${encodedId}`);

      if (!res.data?.status || !res.data.student) {
        Swal.fire("Error", "Failed to load student data", "error");
        return;
      }

      const d = res.data.student;
      const f = d.fees || [];

      setStudent((prev) => ({
        ...prev,

        academic_year_id: d.academic_year_id || "",
        // ===== BASIC DETAILS =====
        name: d.name || "",
        dob: d.dob || "",
        gender: d.gender || "",
        blood_group: d.blood_group || "",
        category: d.category || "",

        aadhaar_no: d.aadhaar_no || "",
        aadhaar_no_formatted: d.aadhaar_no
          ? d.aadhaar_no.replace(/(\d{4})/g, "$1 ").trim()
          : "",

        f_aadhaar_no: d.father_aadhaar_no || "",
        f_aadhaar_no_formatted: d.father_aadhaar_no
          ? d.father_aadhaar_no.replace(/(\d{4})/g, "$1 ").trim()
          : "",

        m_aadhaar_no: d.mother_aadhaar_no || "",
        m_aadhaar_no_formatted: d.mother_aadhaar_no
          ? d.mother_aadhaar_no.replace(/(\d{4})/g, "$1 ").trim()
          : "",

        mobile: d.mobile || "",
        mobile_formatted: d.mobile
          ? d.mobile.replace(/(\d{4})(\d{3})(\d{0,3})/, "$1 $2 $3").trim()
          : "",

        fatherName: d.father_name || "",
        motherName: d.mother_name || "",

        email: d.email || "",

        // ===== ACADEMIC (LOCKED LATER) =====
        classes: d.class_id || "",
        sections: d.section_id || "",
        roll_no: d.roll_no || "",

        // ===== ADDRESS =====
        state: d.state_id || "",
        district: d.district_id || "",
        block: d.block_id || "",
        locality: d.locality || "",
        village: d.village || "",
        post_office: d.post_office || "",
        police_station: d.police_station || "",
        pincode: d.pincode || "",

        // ===== BANK =====
        banks: d.bank_id || "",
        account_no: d.account_no || "",
        ifsc_code: d.ifsc_code || "",

        // ===== OTHER =====
        bpl_no: d.bpl_no || "",
        transportLocations: d.transport_location_id || "",

        //===== FEES =====
        fees: f.map((fee) => Number(fee.fee_id)),

        // image path
        file: d.file || "",
      }));

      // Photo preview
      if (d.file) {
        setCroppedImg(d.file);
        setOldImagePath(d.file);
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Unable to fetch student data", "error");
    }
  };

  useEffect(() => {
    const transportFeeId = fees.find(f => f.is_transport === "1")?.id;

    if (
      isEditMode &&
      transportFeeId &&
      student.fees.includes(transportFeeId)
    ) {
      api.get("/get-tr-location").then(res => {
        if (res.data?.success) {
          setTransportLocations(res.data.data || []);
        }
      });
    }
  }, [isEditMode, fees, student.fees]);


  useEffect(() => {
    if (
      isEditMode &&
      sessions.length > 0 &&
      student.academic_year_id
    ) {
      const matchedSession = sessions.find(
        s => String(s.id) === String(student.academic_year_id)
      );

      setSelectedSession(matchedSession || null);
    }
  }, [sessions, student.academic_year_id, isEditMode]);


  const fetchSessions = async () => {
    try {
      const res = await api.get("school/academic_year/list", {
        headers: { "X-School-Id": schoolId },
      });

      if (res.data?.status !== false) {
        const data = res.data.data || [];

        // active session first
        data.sort((a, b) => (a.status === "active" ? -1 : 1));

        setSessions(data);

        // ✅ ONLY ADD MODE-এ auto select
        if (!isEditMode) {
          const active = data.find((s) => s.status === "active");
          setSelectedSession(active || data[0] || null);
        }

      }
    } catch {
      Swal.fire("Error", "Failed to fetch sessions", "error");
    }
  };


  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = {
      id: localStorage.getItem("id"),
      user_id: localStorage.getItem("user_id"),
      name: localStorage.getItem("name"),
      mobile: localStorage.getItem("mobile"),
    };

    if (!token) {
      navigate("/login");
    } else {
      setUser(storedUser);
    }
  }, []);

  useEffect(() => {
    fetch("https://dgps.co.in/api/get-states")
      .then(res => res.json())
      .then(data => setStates(data.data))
      .catch(error => console.error("Error fetching states:", error));
  }, []);

  useEffect(() => {
    if (student.state) {
      fetch(`https://dgps.co.in/api/get-cities/${student.state}`)
        .then(res => res.json())
        .then(data => setDistricts(data.data))
        .catch(error => console.error("Error fetching districts:", error));
    } else {
      setDistricts([]);
    }
  }, [student.state]);

  useEffect(() => {
    if (student.district) {
      fetch(`https://dgps.co.in/api/get-blocks/${student.district}`)
        .then(res => res.json())
        .then(data => setBlocks(data.data))
        .catch(error => console.error("Error fetching blocks:", error));
    } else {
      setBlocks([]);
    }
  }, [student.district]);

  useEffect(() => {
    fetch("https://dgps.co.in/api/get-bank")
      .then(res => res.json())
      .then(data => setBanks(data.data))
      .catch(error => console.error("Error fetching banks:", error));
  }, []);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const res = await api.get("/get-classes");

        if (res.data && res.data.success) {
          setClass(res.data.data); // backend e data array ache
        } else {
          setClass([]);
          console.warn("Unexpected response:", res.data);
        }
      } catch (error) {
        setClass([]);
        console.error("Error fetching classes:", error);
      }
    };

    fetchClasses();
  }, []);

  useEffect(() => {
    const fetchSection = async () => {
      try {
        const res = await api.get(`/get-sections/${student.classes}`);

        if (res.data && res.data.success) {
          setSections(res.data.data); // backend e data array ache
        } else {
          setSections([]);
          console.warn("Unexpected response:", res.data);
        }
      } catch (error) {
        setSections([]);
        console.error("Error fetching classes:", error);
      }
    };

    fetchSection();
  }, [student.classes]);

  useEffect(() => {
    if (student.classes && student.sections && selectedSession?.id) {
      api
        .get(
          `/students/add/get-used-rolls/${student.classes}/${student.sections}/${selectedSession.id}`,
          {
            headers: { "X-School-Id": schoolId },
          }
        )
        .then((res) => {
          if (res.data?.status) {
            setUsedRolls(res.data.data || []);
          } else {
            setUsedRolls([]);
          }
        })
        .catch(() => {
          setUsedRolls([]);
        });
    } else {
      setUsedRolls([]);
    }
  }, [student.classes, student.sections, selectedSession]);


  // const getRollOptions = () => {
  //   const all = Array.from({ length: 100 }, (_, i) => i + 1);
  //   return all.filter((n) => !usedRolls.includes(n));
  // };

  const getRollOptions = () => {
    let start = 1;
    let end = 100;

    if (selectedSession?.status === "upcoming") {
      start = 101;
      end = 200;
    }

    const all = Array.from({ length: end - start + 1 }, (_, i) => i + start);

    return all.filter((n) => !usedRolls.includes(n));
  };


  useEffect(() => {
    const fetchFees = async () => {
      if (!student.classes) {
        setFees([]);
        setDefaultCheckedFees([]);
        return;
      }

      try {
        const res = await api.get(`/get-fees/${student.classes}?school_id=${schoolId}`);
        if (res.data?.success) {
          setFees(res.data.data || []);
          setDefaultCheckedFees(res.data.default_fees || []);
        } else {
          setFees([]);
          setDefaultCheckedFees([]);
        }
      } catch (err) {
        console.error("Error fetching fees:", err);
        setFees([]);
        setDefaultCheckedFees([]);
      }
    };

    fetchFees();
  }, [student.classes, schoolId]);

  useEffect(() => {
    fetch("https://dgps.co.in/api/get-stream")
      .then(res => res.json())
      .then(data => setStream(data.data))
      .catch(error => console.error("Error fetching stream:", error));
  }, []);

  const normalize = (str = "") =>
    str.toLowerCase().replace(/\s+/g, " ").trim();


  const transportFeeId = fees.find(
    f => f.is_transport === "1"
  )?.id;

  const exclusiveFeeIds = fees
    .filter(f => {
      const t = normalize(f.fee_type);
      return (
        t === "admission" ||
        t === "re admission" ||
        t.includes("hostel admission") ||
        t.includes("hostel re admission")
      );
    })
    .map(f => Number(f.id));


  // ✅ Transport selected (CORRECT)
  const transportSelected =
    transportFeeId && student.fees.includes(Number(transportFeeId));

  const handleFeeChange = async (feeId) => {
    const id = Number(feeId);
    const selectedFee = fees.find(f => Number(f.id) === id);
    const isTransport = selectedFee?.is_transport === "1";

    setStudent(prev => {
      let updatedFees = [...prev.fees];
      const alreadySelected = updatedFees.includes(id);

      // ===== EXCLUSIVE GROUP (Admission + Hostel) =====
      if (exclusiveFeeIds.includes(id)) {
        // remove all other exclusive fees
        updatedFees = updatedFees.filter(
          f => !exclusiveFeeIds.includes(f)
        );

        // toggle current
        if (!alreadySelected) {
          updatedFees.push(id);
        }
      }
      // ===== NORMAL FEES =====
      else {
        updatedFees = alreadySelected
          ? updatedFees.filter(f => f !== id)
          : [...updatedFees, id];
      }

      return { ...prev, fees: updatedFees };
    });

    // ===== TRANSPORT SIDE EFFECT =====
    if (isTransport) {
      try {
        const res = await api.get("/get-tr-location");
        setTransportLocations(res.data?.success ? res.data.data : []);
      } catch {
        setTransportLocations([]);
      }
    }
  };

  const handleAllSelect = async (event) => {
    if (event.target.checked) {

      const nonExclusiveIds = fees
        .filter(f => !exclusiveFeeIds.includes(Number(f.id)))
        .map(f => Number(f.id));

      const alreadySelectedExclusive = student.fees.find(f =>
        exclusiveFeeIds.includes(f)
      );

      const finalExclusive =
        alreadySelectedExclusive || exclusiveFeeIds[0] || null;

      const finalFees = finalExclusive
        ? [...nonExclusiveIds, finalExclusive]
        : nonExclusiveIds;

      setStudent(prev => ({
        ...prev,
        fees: finalFees
      }));

      if (finalFees.includes(transportFeeId)) {
        try {
          const res = await api.get("/get-tr-location");
          setTransportLocations(res.data?.success ? res.data.data : []);
        } catch {
          setTransportLocations([]);
        }
      }

    } else {
      setStudent(prev => ({
        ...prev,
        fees: [],
        transportLocations: ""
      }));
      setTransportLocations([]);
    }
  };


  const isAllSelected = fees
    .filter(f => !exclusiveFeeIds.includes(Number(f.id)))
    .every(f => student.fees.includes(Number(f.id)));

  const handleChange = (e) => {
    let { name, value } = e.target;

    // Email should always be lowercase
    if (name === "email") {
      setStudent((prev) => ({
        ...prev,
        [name]: value.toLowerCase(),
      }));
      return;
    }

    // Numeric fields (Only digits allowed)
    const numericFields = ["aadhaar_no", "f_aadhaar_no", "m_aadhaar_no", "mobile", "pincode", "account_no", "roll_no", "admission_fees"];
    if (numericFields.includes(name)) {
      value = value.replace(/\D/g, ""); // Remove non-digit characters

      // Aadhaar Formatting (XXXX XXXX XXXX)
      if (["aadhaar_no", "f_aadhaar_no", "m_aadhaar_no"].includes(name)) {
        if (value.length > 12) value = value.slice(0, 12);
        let formattedValue = value.replace(/(\d{4})/g, "$1 ").trim();

        setStudent((prev) => ({
          ...prev,
          [name]: value, // Unformatted value for database
          [`${name}_formatted`]: formattedValue, // Formatted value for UI
        }));
        return;
      }

      // Mobile Formatting (XXXX XXX XXX)
      if (name === "mobile") {
        if (value.length > 10) value = value.slice(0, 10);
        let formattedValue = value.replace(/(\d{4})(\d{3})(\d{0,3})/, "$1 $2 $3").trim();

        setStudent((prev) => ({
          ...prev,
          [name]: value, // Unformatted value for database
          [`${name}_formatted`]: formattedValue, // Formatted value for UI
        }));
        return;
      }

      // Pincode (Max 6 digits)
      if (name === "pincode" && value.length > 6) {
        value = value.slice(0, 6);
      }

      setStudent((prev) => ({ ...prev, [name]: value }));
      return;
    }

    // Text Fields (No digits allowed, auto-uppercase)
    const textFields = ["name", "fatherName", "motherName", "state", "district", "block", "locality", "village", "post_office", "police_station"];
    if (textFields.includes(name)) {
      value = value.replace(/[^A-Za-z\s]/g, ""); // Remove all digits & special characters
      value = value.toUpperCase(); // Convert to uppercase
    }

    setStudent((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // File select → open modal
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        setModalOpen(true);
      };
      reader.readAsDataURL(file);
    }
  };

  // Crop & Save
  const doCrop = () => {
    if (cropper) {
      const canvas = cropper.getCanvas();
      if (canvas) {
        canvas.toBlob((blob) => {
          if (blob) {
            const file = new File([blob], "student.jpg", { type: "image/jpeg" });
            setStudent((prev) => ({ ...prev, file: file }));
            setCroppedImg(URL.createObjectURL(blob));
            setModalOpen(false);
          }
        }, "image/jpeg");
      }
    }
  };

  // Custom Styles for React-Select to Match Input Field
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      height: 56, // Same as MUI TextField
      minHeight: 56,
      backgroundColor: "#ffffff", // White background
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff", // Dropdown menu background white
      zIndex: 1000,
    }),
  };
  const buttonStyle = {
    padding: "8px 18px",
    backgroundColor: "#0077cc",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const school_id = localStorage.getItem("school_id");

    if (!token || !school_id) {
      navigate("/login");
      return;
    }

    if (!selectedSession) {
      Swal.fire("Required", "Please select Academic Session", "warning");
      return;
    }

    try {
      let finalImagePath = oldImagePath || "";

      // ✅ Upload image ONLY if new file selected
      if (student.file instanceof File) {
        const formData = new FormData();
        formData.append("file", student.file);

        const imgRes = await api.post("/upload-student-image", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (!imgRes?.data?.success) {
          Swal.fire("Image Upload Failed", imgRes?.data?.message || "", "error");
          return;
        }

        finalImagePath = imgRes.data.file_path;
      }

      // -------- FEES PAYLOAD (transport বাদ) --------
      const filteredFees = (student.fees || [])
        .map((id) => {
          const f = fees.find((x) => String(x.id) === String(id));

          // transport কখনো fees payload এ যাবে না
          if (!f || f.fee_type.toLowerCase() === "transport") {
            return null;
          }

          return {
            id: Number(f.id),
            amount: Number(f.amount),
          };
        })
        .filter(Boolean);

      // -------- TRANSPORT VALIDATION (SAFE) --------
      const transportFee = fees.find(f => f.is_transport === "1");
      const transportFeeId = transportFee ? Number(transportFee.id) : null;

      // 👉 transport fee থাকলে + select করলে তবেই location required
      if (
        transportFeeId &&
        student.fees.includes(transportFeeId) &&
        !student.transportLocations
      ) {
        Swal.fire(
          "Required",
          "Please select Transport Location",
          "warning"
        );
        return;
      }


      const payload = {
        ...student,
        school_id,
        created_by: localStorage.getItem("id"),
        academic_year_id: selectedSession?.id,
        file: finalImagePath,
        old_image: isEditMode ? oldImagePath : "",
        fees: filteredFees,
      };

      const url = isEditMode
        ? `/update-student/${editStudentId}`
        : "/add-student";

      const res = await api.post(url, payload);
      const data = res?.data || {};

      if (!data.status) {
        Swal.fire("Failed", data.message || "Operation failed", "error");
        return;
      }

      /* =====================================================
         ✅ ADD MODE → SHOW PRINT BUTTON
      ===================================================== */
      if (!isEditMode) {
        const studentId = data.student_id;

        await Swal.fire({
          icon: "success",
          title: "Student Added Successfully",
          html: `
          <p>Student has been added successfully.</p>
          ${studentId
              ? `<button id="print-btn"
                    style="padding:8px 18px; margin-top:12px;
                           background:#0050a8; color:#fff;
                           border:none; border-radius:6px;
                           cursor:pointer;">
                   Print Admission Form
                 </button>`
              : ""
            }
        `,
          showConfirmButton: false,
          didOpen: () => {
            const btn = document.getElementById("print-btn");
            if (btn && studentId) {
              btn.addEventListener("click", () => {
                Swal.close();
                handlePrintAdmissionForm(studentId); // 🔥 PRINT
              });
            }
          },
        });

      } else {
        /* =====================================================
           ✅ EDIT MODE → SIMPLE SUCCESS
        ===================================================== */
        await Swal.fire({
          icon: "success",
          title: "Student Updated Successfully",
          timer: 1500,
          showConfirmButton: false,
        });
      }

      navigate("/admin/view-student");

    } catch (err) {
      Swal.fire("Unexpected Error", err?.message || "", "error");
    }
  };


  const handlePrintAdmissionForm = async (studentId) => {
    try {
      if (!studentId) {
        Swal.fire("Error", "Invalid Student ID", "error");
        return;
      }

      Swal.fire({
        title: "Preparing Admission Form...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const res = await api.post(`/student_data/${studentId}`);
      Swal.close();

      if (!res?.data?.status || !res.data.data) {
        Swal.fire("Error", "Failed to fetch student details", "error");
        return;
      }

      const data = res.data.data;

      const school = Array.isArray(data.school) ? data.school[0] || {} : {};
      const address = data.address || {};
      const bank = data.bank || {};
      const fees = Array.isArray(data.fees) ? data.fees : [];

      const logoUrl = school.logo
        ? `https://dgps.co.in/public/admin/assets/img/schools/logo/${school.logo}`
        : "https://dgps.co.in/public/admin/assets/img/logo.png";

      const photoUrl =
        data.file ||
        "https://dgps.co.in/public/admin/assets/img/default-stu.png";

      const totalAmount = fees.reduce(
        (sum, f) => sum + (parseFloat(f.amount || 0) || 0),
        0
      );

      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        Swal.fire(
          "Popup Blocked",
          "Please allow pop-ups for this site to print the form.",
          "warning"
        );
        return;
      }

      printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8" />
  <title>Student Admission Form</title>
  <style>
    * { box-sizing: border-box; }

    body {
      font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif;
      background: #eef2f7;
      margin: 0;
      padding: 20px;
    }

    .page-frame {
      max-width: 820px;
      margin: 0 auto;
      background: #f5f8ff;
      border-radius: 14px;
      padding: 10px;
      border: 3px solid #0050a8;
    }

    .page-inner {
      border-radius: 10px;
      border: 2px solid #0050a8;
      background: #ffffff;
      padding: 22px 26px 26px;
    }

    /* ------------ HEADER ------------ */
    .header {
      display: flex;
      align-items: center;
      gap: 18px;
      margin-bottom: 10px;
    }

    .school-logo {
      width: 90px;
      height: 90px;
      object-fit: contain;
    }

    .school-text {
      flex: 1;
      text-align: center;
    }

    .school-name {
      font-size: 22px;
      font-weight: 700;
      letter-spacing: 0.6px;
      color: #00408a;
      text-transform: uppercase;
    }

    .school-address {
      font-size: 12px;
      color: #444;
      margin-top: 3px;
    }

    .school-contact {
      font-size: 11px;
      color: #555;
      margin-top: 2px;
    }

    .top-divider {
      margin-top: 10px;
      border-bottom: 2px solid #0050a8;
    }

    /* ------------ TITLE ------------ */
    .title-bar {
      margin: 18px auto 18px;
      max-width: 420px;
      background: linear-gradient(90deg, #00428f, #0070e0);
      color: #ffffff;
      text-align: center;
      padding: 8px 18px;
      border-radius: 999px;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      box-shadow: 0 3px 8px rgba(0, 64, 138, 0.25);
    }

    /* ------------ MAIN LAYOUT (Option A) ------------ */
    .layout-main {
      display: flex;
      align-items: flex-start;
      gap: 18px;
      margin-top: 4px;
    }

    .left-column {
      flex: 1.6;
      min-width: 0;
    }

    

    /* ------------ CARDS ------------ */
    .section-heading {
      font-size: 13px;
      font-weight: 600;
      color: #00408a;
      border-bottom: 1px solid #d0d8ea;
      padding-bottom: 4px;
      margin-bottom: 6px;
    }

    .card-soft {
      border-radius: 10px;
      border: 1px solid #d3e0f5;
      background: #f9fbff;
      box-shadow: 0 2px 6px rgba(0,0,0,0.03);
      padding: 12px 14px 10px;
      margin-bottom: 12px;
      font-size: 12px;
    }

    .card {
      border-radius: 10px;
      border: 1px solid #d3e0f5;
      background: #ffffff;
      box-shadow: 0 1px 4px rgba(0,0,0,0.03);
      padding: 10px 14px 8px;
      margin-bottom: 12px;
      font-size: 12px;
    }

    .student-grid {
      display: grid;
      grid-template-columns: 1.1fr 1.1fr;
      column-gap: 40px;
      row-gap: 4px;
      font-size: 12px;
    }

    .field-row {
      display: flex;
      margin: 2px 0;
    }

    .field-label {
      width: 95px;
      font-weight: 600;
      color: #222;
    }

    .field-value {
      flex: 1;
      color: #333;
    }

    .card-grid-two {
      display: grid;
      grid-template-columns: 1.1fr 1.1fr;
      column-gap: 40px;
    }

    .card-row {
      display: flex;
      margin: 3px 0;
    }

    .card-label {
      width: 95px;
      font-weight: 600;
      color: #222;
    }

    .card-value {
      flex: 1;
      color: #333;
    }

    /* ------------ PHOTO PANEL (separate right column) ------------ */
    .photo-panel {
      border-radius: 16px;
      border: 1px solid #d3e0f5;
      background: radial-gradient(circle at 10% 0%, #e8f4ff 0%, #c8e5ff 45%, #f5fbff 100%);
      box-shadow: 0 4px 12px rgba(0,0,0,0.12);
      padding: 10px;
      text-align: center;
    }

    .photo-title {
      font-size: 11px;
      font-weight: 600;
      color: #00408a;
      margin-bottom: 6px;
      letter-spacing: 0.4px;
      text-transform: uppercase;
    }

    .photo-box {
      border-radius: 12px;
      overflow: hidden;
      background: #e6f6ff;
      border: 2px solid #00a0e3;
    }

    .photo-img {
      width: 100px;
      object-fit: cover;
    }

    /* ------------ FEES TABLE ------------ */
    .fees-table-wrapper {
      border-radius: 10px;
      border: 1px solid #d3e0f5;
      overflow: hidden;
      box-shadow: 0 1px 4px rgba(0,0,0,0.04);
    }

    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 12px;
    }

    thead {
      background: linear-gradient(90deg, #00428f, #0070e0);
      color: #ffffff;
    }

    th, td {
      padding: 8px 10px;
      text-align: left;
    }

    th {
      font-weight: 600;
      font-size: 12px;
    }

    tbody tr:nth-child(even) {
      background: #f4f7ff;
    }

    tbody tr:nth-child(odd) {
      background: #ffffff;
    }

    .amount-cell {
      text-align: right;
    }

    .total-row {
      background: #dbe7ff !important;
      font-weight: 700;
      border-top: 1px solid #b4c7f2;
    }

    @media print {
      body {
        background: #ffffff;
        padding: 0;
      }
      .page-frame {
        border-radius: 0;
        border-width: 2px;
      }
      .page-inner {
        box-shadow: none;
        border-radius: 0;
      }
      .layout-main {
        gap: 14px;
      }
    }
  </style>
</head>
<body>
  <div class="page-frame">
    <div class="page-inner">

      <!-- HEADER -->
      <div class="header">
        <img src="${logoUrl}" class="school-logo" />
        <div class="school-text">
          <div class="school-name">${school.name || ""}</div>
          <div class="school-address">${school.address || ""}</div>
          <div class="school-contact">
            ${school.phone ? "Phone: " + school.phone : ""}
            ${school.phone && school.email ? " | " : ""}
            ${school.email ? "Email: " + school.email : ""}
          </div>
        </div>
      </div>
      <div class="top-divider"></div>

      <!-- TITLE -->
      <div class="title-bar">Student Admission Form</div>

      <!-- MAIN LAYOUT (LEFT: DETAILS, RIGHT: PHOTO) -->
      <div class="layout-main">

        <!-- LEFT COLUMN -->
        <div class="left-column">
          <!-- STUDENT INFO -->
          <div class="card-soft">
            <div class="section-heading">Student Information</div>
            <div class="student-grid">
              <div>
                <div class="field-row">
                  <div class="field-label">Name:</div>
                  <div class="field-value">${data.name || "-"}</div>
                </div>
                <div class="field-row">
                  <div class="field-label">Father's Name:</div>
                  <div class="field-value">${data.father_name || "-"}</div>
                </div>
                <div class="field-row">
                  <div class="field-label">Mother's Name:</div>
                  <div class="field-value">${data.mother_name || "-"}</div>
                </div>
                <div class="field-row">
                  <div class="field-label">Gender:</div>
                  <div class="field-value">${data.gender || "-"}</div>
                </div>
              </div>
              <div>
                <div class="field-row">
                  <div class="field-label">Date of Birth:</div>
                  <div class="field-value">${data.dob || "-"}</div>
                </div>
                <div class="field-row">
                  <div class="field-label">Aadhaar No:</div>
                  <div class="field-value">${data.aadhaar_no || "-"}</div>
                </div>
                <div class="field-row">
                  <div class="field-label">Blood Group:</div>
                  <div class="field-value">${data.blood_group || "-"}</div>
                </div>
                <div class="field-row">
                  <div class="field-label">Mobile:</div>
                  <div class="field-value">${data.mobile || "-"}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- ADDRESS -->
          <div class="card">
            <div class="section-heading">Address</div>
            <div class="card-grid-two">
              <div>
                <div class="card-row">
                  <div class="card-label">Village:</div>
                  <div class="card-value">${address.village || "-"}</div>
                </div>
                <div class="card-row">
                  <div class="card-label">Post Office:</div>
                  <div class="card-value">${address.post_office || "-"}</div>
                </div>
                <div class="card-row">
                  <div class="card-label">Police Station:</div>
                  <div class="card-value">${address.police_station || "-"}</div>
                </div>
                <div class="card-row">
                  <div class="card-label">Pin Code:</div>
                  <div class="card-value">${address.pincode || "-"}</div>
                </div>
              </div>
              <div>
                <div class="card-row">
                  <div class="card-label">District:</div>
                  <div class="card-value">${address.city || "-"}</div>
                </div>
                <div class="card-row">
                  <div class="card-label">State:</div>
                  <div class="card-value">${address.state || "-"}</div>
                </div>
                <div class="card-row">
                  <div class="card-label">Block:</div>
                  <div class="card-value">${address.block || "-"}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- ACADEMIC -->
          <div class="card">
            <div class="section-heading">Academic Details</div>
            <div class="card-grid-two">
              <div>
                <div class="card-row">
                  <div class="card-label">Class:</div>
                  <div class="card-value">${data.class_name || "-"}</div>
                </div>
                <div class="card-row">
                  <div class="card-label">Section:</div>
                  <div class="card-value">${data.section_name || "-"}</div>
                </div>
              </div>
              <div>
                <div class="card-row">
                  <div class="card-label">Roll No:</div>
                  <div class="card-value">${data.roll_no || "-"}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- FEES -->
          <div class="card">
            <div class="section-heading">Fees Details</div>
            <div class="fees-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Fee Name</th>
                    <th class="amount-cell">Amount (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  ${fees.length
          ? fees
            .map(
              (f) => `
                    <tr>
                      <td>${f.fee_name || "-"}</td>
                      <td class="amount-cell">${(
                  parseFloat(f.amount || 0) || 0
                ).toFixed(2)}</td>
                    </tr>`
            )
            .join("")
          : `<tr><td colspan="2">No fees configured</td></tr>`
        }
                  <tr class="total-row">
                    <td>Total</td>
                    <td class="amount-cell">${totalAmount.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- RIGHT COLUMN (PHOTO ONLY) -->
        <div class="right-column">
          <div class="photo-panel">
            <div class="photo-title">Student Photo</div>
            <div class="photo-box">
              <img src="${photoUrl}" class="photo-img" />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <script>
    window.onload = function () {
      window.print();
    };
  </script>
</body>
</html>
    `);

      printWindow.document.close();
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong while generating form", "error");
    }
  };

  const bloodGroupOptions = [
    { label: "A+", value: "A+" },
    { label: "A-", value: "A-" },
    { label: "B+", value: "B+" },
    { label: "B-", value: "B-" },
    { label: "AB+", value: "AB+" },
    { label: "AB-", value: "AB-" },
    { label: "O+", value: "O+" },
    { label: "O-", value: "O-" }
  ];

  const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" }
  ];

  const categoryOptions = [
    { label: "General", value: "General" },
    { label: "OBC", value: "OBC" },
    { label: "SC", value: "SC" },
    { label: "ST", value: "ST" }
  ];

  return (

    <Box
      className="student-form-page"
      sx={{
        width: "100%",
        maxWidth: "1180px",
        margin: "0px auto",
        p: { xs: 0, md: 1 },
      }}
    >
      <Paper
        sx={{
          padding: { xs: 2, md: 3 },
          boxShadow: "0 18px 46px rgba(23,32,51,0.12)",
          borderRadius: 3,
          border: "1px solid rgba(78,102,135,0.16)",
        }}
      >
        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: "bold", color: "#1976D2", mb: 3 }}>
          Student Information Form
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Name" name="name" value={student.name} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} required /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth type="date" name="dob" value={student.dob || ""} onChange={handleChange} required /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Student Aadhaar No" name="aadhaar_no" value={student.aadhaar_no_formatted || ""} onChange={handleChange} /></Grid>

            <Grid item xs={12} sm={6}>
              <Select
                styles={selectStyles}
                options={bloodGroupOptions}
                value={bloodGroupOptions.find(o => o.value === student.blood_group) || null}
                onChange={selected =>
                  setStudent({ ...student, blood_group: selected?.value || "" })
                }
                placeholder="Select Blood Group"
                isClearable
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Select
                styles={selectStyles}
                options={genderOptions}
                value={genderOptions.find(o => o.value === student.gender) || null}
                onChange={selected =>
                  setStudent({ ...student, gender: selected?.value || "" })
                }
                placeholder="Select Gender"
                isClearable
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Select
                styles={selectStyles}
                options={categoryOptions}
                value={categoryOptions.find(o => o.value === student.category) || null}
                onChange={selected =>
                  setStudent({ ...student, category: selected?.value || "" })
                }
                placeholder="Select Social Category"
                isClearable
              />
            </Grid>

            <Grid item xs={12} sm={6}><TextField fullWidth label="Father's Name" name="fatherName" value={student.fatherName || ""} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} required /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Father Aadhaar No" name="f_aadhaar_no" value={student.f_aadhaar_no_formatted || ""} onChange={handleChange} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Mother's Name" name="motherName" value={student.motherName} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Mother Aadhaar No" name="m_aadhaar_no" value={student.m_aadhaar_no_formatted || ""} onChange={handleChange} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Mobile" name="mobile" disabled={isEditMode} value={student.mobile_formatted || ""} onChange={handleChange} required /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Email" name="email" value={student.email || ""} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toLowerCase()} /></Grid>

            <Grid item xs={12}>

              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2, }}>
                Address
              </Typography>

            </Grid>
            <Grid item xs={12} sm={6}>
              <Select
                styles={selectStyles}
                options={[{ id: "", name: "Select State" }, ...states]}
                getOptionLabel={e => e.name}
                getOptionValue={e => e.id}
                value={states.find(s => String(s.id) === String(student.state)) || null}
                onChange={selected => setStudent({ ...student, state: selected?.id || "" })}
                placeholder="Select State"
                isClearable
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Select
                styles={selectStyles}
                options={[{ id: "", name: "Select District" }, ...districts]}
                getOptionLabel={e => e.name}
                getOptionValue={e => e.id}
                value={districts.find(d => String(d.id) === String(student.district)) || null}
                onChange={selected => setStudent({ ...student, district: selected?.id || "" })}
                isDisabled={!student.state}
                placeholder="Select District"
                isClearable
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Select
                styles={selectStyles}
                options={[{ id: "", name: "Select Block" }, ...blocks]}
                getOptionLabel={e => e.name}
                getOptionValue={e => e.id}
                value={blocks.find(b => String(b.id) === String(student.block)) || null}
                onChange={selected => setStudent({ ...student, block: selected?.id || "" })}
                isDisabled={!student.district}
                placeholder="Select Block"
                isClearable
              />
            </Grid>


            <Grid item xs={12} sm={6}><TextField fullWidth label="Locality" name="locality" value={student.locality} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Village" name="village" value={student.village} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Post Office" name="post_office" value={student.post_office} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Police Station" name="police_station" value={student.police_station} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Pin Code" name="pincode" value={student.pincode || ""} onChange={handleChange} /></Grid>

            <Grid item xs={12}>

              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2 }}>
                School Details
              </Typography>

            </Grid>

            <Grid item xs={12} sm={6}>
              <Select
                styles={selectStyles}
                options={sessions}
                getOptionLabel={(e) => `${e.session_name} (${e.status})`}
                getOptionValue={(e) => e.id}
                value={selectedSession}
                onChange={(val) => {
                  setSelectedSession(val);
                  setStudent(prev => ({
                    ...prev,
                    academic_year_id: val?.id || ""
                  }));
                }}
                //isDisabled={isEditMode}
                placeholder="Select Academic Session *"
                isClearable={false}
              />
            </Grid>


            <Grid item xs={12} sm={6}>


              <Select
                styles={selectStyles}
                options={[{ id: "", class_name: "Select Class" }, ...classes]}
                getOptionLabel={e => e.class_name}
                getOptionValue={e => e.id}
                value={
                  classes.find(c => String(c.id) === String(student.classes)) || null
                }
                onChange={selected => setStudent({ ...student, classes: selected?.id || "" })}
                isDisabled={isEditMode && Number(schoolId) !== 33}
                placeholder="Select Class *"
                isClearable
              />
            </Grid>


            <Grid item xs={12} sm={6}>
              <Select
                styles={selectStyles}
                options={[{ id: "", section_name: "Select Sections" }, ...sections]}
                getOptionLabel={e => e.section_name}
                getOptionValue={e => e.id}
                value={
                  sections.find(s => String(s.id) === String(student.sections)) || null
                }
                onChange={selected => setStudent({ ...student, sections: selected?.id || "" })}
                //isDisabled={isEditMode || !student.classes}
                placeholder="Select Sections *"
                isClearable
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Autocomplete
                fullWidth
                options={getRollOptions()}
                getOptionLabel={(opt) => opt.toString()}
                value={student.roll_no || null}
                onChange={(_, v) => setStudent((prev) => ({ ...prev, roll_no: v }))}
                renderInput={(params) => (
                  <TextField {...params} label="Roll No" required />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6}><TextField fullWidth label="BPL Number" name="bpl_no" onChange={handleChange} /></Grid>
            {/* <Grid item xs={12} sm={6}><TextField fullWidth label="Admission Fees" name="admission_fees" value={student.admission_fees || ""} onChange={handleChange}   /></Grid> */}


            {/* Fees Structure Section */}
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2 }}>
                Academic Details
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Paper
                elevation={4}
                sx={{
                  padding: 3,
                  borderRadius: 3,
                  backgroundColor: "#FAFAFA",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
                }}
              >
                <FormGroup>
                  <Grid container spacing={2}>

                    {/* ===== All Select ===== */}
                    <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isAllSelected}
                            onChange={handleAllSelect}
                            sx={{
                              transform: "scale(1.2)",
                              "&.Mui-checked": { color: "#0D47A1" },
                            }}
                          />
                        }
                        label={
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: "#0D47A1",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px"
                            }}
                          >
                            All Select
                          </Typography>
                        }
                      />
                    </Grid>

                    {/* ===== Fees Checkboxes ===== */}
                    {fees
                      .filter(
                        fee => !defaultCheckedFees.includes(fee.fee_type.toLowerCase())
                      )
                      .map((fee) => {
                        const isChecked = student.fees.includes(Number(fee.id));

                        return (
                          <Grid item xs={12} sm={6} key={fee.id}>
                            <Paper
                              onClick={() => handleFeeChange(fee.id)}
                              sx={{
                                padding: 2,
                                border: "2px solid #0D47A1",
                                borderRadius: "8px",
                                cursor: "pointer",
                                backgroundColor: isChecked ? "#E3F2FD" : "#F5F5F5",
                                transition: "0.3s ease",
                                "&:hover": { backgroundColor: "#E3F2FD" }
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={isChecked}
                                    onChange={() => handleFeeChange(fee.id)}
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{
                                      "&.Mui-checked": { color: "#0D47A1" },
                                      transform: "scale(1.2)"
                                    }}
                                  />
                                }
                                label={
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      color: "#0D47A1",
                                      textTransform: "capitalize"
                                    }}
                                  >
                                    {fee.fee_type}
                                  </Typography>
                                }
                              />
                            </Paper>
                          </Grid>
                        );
                      })}

                    {transportSelected && (
                      <Grid item xs={12}>
                        <Paper
                          sx={{
                            mt: 2,
                            p: 2,
                            borderRadius: 2,
                            backgroundColor: "#F9FAFB",
                            border: "1px solid #E0E0E0"
                          }}
                        >
                          <Typography
                            sx={{
                              mb: 1,
                              fontWeight: 600,
                              color: "#0D47A1"
                            }}
                          >
                            Transport Location
                          </Typography>

                          <Select
                            styles={selectStyles}
                            options={[
                              { id: "", location_name: "Select Transport Location" },
                              ...transportLocations
                            ]}
                            getOptionLabel={(e) => e.location_name}
                            getOptionValue={(e) => e.id}
                            value={
                              transportLocations.find(
                                t => String(t.id) === String(student.transportLocations)
                              ) || null
                            }
                            onChange={(selected) =>
                              setStudent(prev => ({
                                ...prev,
                                transportLocations: selected?.id || ""
                              }))
                            }
                            placeholder="Select Transport Location"
                            isClearable
                          />
                        </Paper>
                      </Grid>
                    )}



                  </Grid>
                </FormGroup>
              </Paper>
            </Grid>

            <Grid item xs={12}>

              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2 }}>
                Bank Details
              </Typography>

            </Grid>

            <Grid item xs={12} sm={12}>
              <Select
                styles={selectStyles}
                options={[{ id: "", name: "Select Bank" }, ...banks]}
                getOptionLabel={e => e.name}
                getOptionValue={e => e.id}
                value={banks.find(b => String(b.id) === String(student.banks)) || null}
                onChange={selected => setStudent({ ...student, banks: selected?.id || "" })}
                placeholder="Select Bank "
                isClearable
              />
            </Grid>

            <Grid item xs={12} sm={6}><TextField fullWidth label="Account Number" name="account_no" value={student.account_no || ""} onChange={handleChange} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="IFSC Code" name="ifsc_code" value={student.ifsc_code || ""} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>


            {/* Image Upload Section */}

            <Grid item xs={12} sm={12} md={12}>

              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2 }}>
                Upload Student Image
              </Typography>

              <input type="file" accept="image/jpeg" onChange={handleFileChange} />
              {croppedImg && (
                <div style={{ marginTop: "10px" }}>
                  <img src={croppedImg} alt="Cropped Preview" style={{ width: "100px", borderRadius: "6px" }} />
                </div>
              )}
            </Grid>

          </Grid>

          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 3, py: 1.5, fontSize: 16 }}>
            {isEditMode ? "Edit Student Details" : "Add New Student"}
          </Button>
        </form>

        {/* Crop Modal */}
        <Modal
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          style={{
            content: {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "500px",
              height: "500px",
              padding: "20px",
            },
          }}
        >
          <h3 style={{ marginBottom: "10px" }}>Crop Image</h3>
          {image && (
            <div style={{ width: "100%", height: "400px" }}>
              <Cropper
                src={image}
                stencilComponent={RectangleStencil}
                onChange={setCropper}
                className="cropper"
              />
            </div>
          )}
          <div style={{ textAlign: "right", marginTop: "15px" }}>
            <button onClick={() => setModalOpen(false)} style={{ marginRight: "10px", ...buttonStyle }}>
              Cancel
            </button>
            <button onClick={doCrop} style={buttonStyle}>
              Crop & Save
            </button>
          </div>
        </Modal>
      </Paper>
    </Box>
  );
};

export default AddStudent;

